import { mediaSlider } from './media';

export const initSliders = () => {
    mediaSlider.init();
}